import React, { useState, useEffect } from "react";
import columns from "../../../columns/PaymentGatway";
import ConfirmationModal from "../../../components/global/modal/ConfirmationModal.jsx";
import Pagination from "../../../components/global/pagination/Pagination.jsx";
import { GetAllPaymentGatwaysApi, UpdatePaymentGatwayStatusApi, UpdategetwayApi } from "../../../api/request/settings/paymentGatway.js";
import TableWithSkeleton from "../../../components/global/table/TableWithSkeleton";
import toast from "react-hot-toast";
import Edit from "../../../assets/Edit.jsx";
import ModalComponent from "../../../components/global/modal/ModalComponent.jsx";
import { Form, Switch, Input, Space, Select } from "antd";
import LoadableButton from "../../../components/buttons/LoadableButton.jsx";
import MySegmented from "../../../components/segmented/Segmented.jsx";
import useModulePermissions from "../../../hooks/useModulePermissions.jsx";

export default function PaymentGatway() {

  const paymentGatewayPermissions = useModulePermissions('setting', 'psp');
  const canUpdate = !!paymentGatewayPermissions.update;

  const [form] = Form.useForm();
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecord, setTotalRecord] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [selectedPaymentGatway, setSelectedPaymentGatway] = useState(null);
  const [isStatusConfirmOpen, setIsStatusConfirmOpen] = useState(false);
  const [isStatusConfirmLoading, setIsStatusConfirmLoading] = useState(false);
  const [selectedid, setSelectedid] = useState(null);
  const [isOpenEditModal, setIsOpenEditModal] = useState(false);
  const [isEditTraderLoading, setIsEditTraderLoading] = useState(false);
  const [value, setValue] = useState("Deposit");

  const statusHandler = (value) => {
    setSelectedPaymentGatway(value);
    setIsStatusConfirmOpen(true);
  }


  const getPaymentGatways = async () => {
    try {
      setIsLoading(true);
      let params = {
        PageNumber: page,
        PageSize: pageSize,
        type: value === "Deposit" ? 1 : 2
      }
      const { data } = await GetAllPaymentGatwaysApi(new URLSearchParams(params).toString());
      if (data?.success) {
        setData(
          data?.data?.map((item) => {
            return {
              ...item,
              status: <Switch onChange={() => statusHandler(item)} checkedChildren="Active" unCheckedChildren="Inactive" checked={item?.isActive} />,
              action: (<>
                <button type="button" onClick={() => handleEditClick(item)}><Edit /></button>
              </>
              ),
            }
          })
        );
        setTotalRecord(data?.totalRecords);
      }
      setIsLoading(false);
    } catch (error) {
      setData([]);
      setIsLoading(false);
    }
  }

  const statusChangeConfirm = async () => {
    try {
      setIsStatusConfirmLoading(true);

      let params = {
        Status: !selectedPaymentGatway?.isActive
      }

      const { data } = await UpdatePaymentGatwayStatusApi(selectedPaymentGatway?.id, new URLSearchParams(params).toString());
      if (data?.success) {
        getPaymentGatways();
        toast.success(data?.message);
      }

      setIsStatusConfirmLoading(false);
      setIsStatusConfirmOpen(false);
    } catch (error) {
      setIsStatusConfirmLoading(false);
    }
  }


  const handleEditSubmit = async (value) => {
    try {
      let apiParams = {
        paymentMethodName: value?.paymentMethodName,
        processingTime: `${value.processingTimeValue} ${value.processingTimeUnit}`,
        fees: parseFloat(value?.fees) || 0,
        description: value?.description || ""
      };
      setIsEditTraderLoading(true);
      const { data } = await UpdategetwayApi(selectedid, apiParams);
      if (data?.success) {
        toast.success(data?.message);
        form.resetFields();
        setIsEditTraderLoading(false);
        setIsOpenEditModal(false);
        getPaymentGatways();
      }
    } catch (error) {
      toast.error(error?.response?.data?.error?.message);
      setIsEditTraderLoading(false);
    }
  };


  const handleEditClick = (item) => {
    setSelectedid(item?.id);
    form.setFieldsValue({
      paymentMethodName: item?.name,
      // processingTime: parseFloat(item?.processingTime.replace(/\s*H\s*$/i, '')),
      processingTimeValue: parseFloat(item?.processingTime?.replace(/\s*H\s*$/i, '')),
      processingTimeUnit: item?.processingTime?.match(/\s*H\s*$/i) ? 'hours' : 'minutes',
      fees: item?.fees || 0,
      description: item?.description || ""
    });
    setIsOpenEditModal(true);
  }

  useEffect(() => {
    getPaymentGatways();
  }, [page, pageSize, value]);

  return (
    <div>
      <div className="my-5">
        <MySegmented options={["Deposit", "Withdraw"]} value={value} setValue={setValue} />
      </div>
      <div>
        <div className="border border-gray-200 rounded-xl overflow-hidden bg-white">
          <TableWithSkeleton
            columns={columns}
            data={data}
            loading={isLoading}
            hiddenColumns={!canUpdate ? ["Actions", "Status"] : []}
            page={page}
            pageSize={pageSize}
          />
        </div>
        <Pagination total={totalRecord} page={page} setPage={setPage} pageSize={pageSize} setPageSize={setPageSize} />
      </div>

      {/* Payment gatway status change confirmation modal */}
      <ConfirmationModal
        isOpen={isStatusConfirmOpen}
        setIsOpen={setIsStatusConfirmOpen}
        message='Are you sure to change the payment gatway status?'
        onConfirm={statusChangeConfirm}
        isLoading={isStatusConfirmLoading}
        loadingLabel='Changing status...'
      />

      {/* Update user modal */}
      <ModalComponent isOpen={isOpenEditModal} setIsOpen={setIsOpenEditModal} title="Update Payment Gateway" width={500}>
        <Form className="w-full" autoComplete="off" form={form} onFinish={handleEditSubmit} >
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <p className="text-[#585F70] font-semibold mb-[2px]">Payment Method Name</p>
              <Form.Item name="paymentMethodName" rules={[{ required: true, message: 'Please enter payment method name.' }]}>
                <Input placeholder="Payment method name" className="w-full mt-1" disabled={true} />
              </Form.Item>
            </div>
            {/* <div>
              <p className="text-[#585F70] font-semibold mb-[2px]">Processing Time</p>
              <Form.Item name="processingTime" rules={[
                { required: true, message: 'Please enter processing time.' },
                {
                  validator: (_, value) => value < 0
                    ? Promise.reject(new Error('Processing time cannot be less than 0.'))
                    : Promise.resolve(),
                },
              ]}>
                <Input type="number" step="0.1" addonAfter="H" placeholder="Processing time" className="w-full mt-1" />
              </Form.Item>
            </div> */}
            <div>
              <p className="text-[#585F70] font-semibold mb-[2px]">Processing Time</p>
              <Form.Item name="processingTimeValue" rules={[
                { required: true, message: 'Please enter processing time.' },
                {
                  validator: (_, value) => value < 0
                    ? Promise.reject(new Error('Processing time cannot be less than 0.'))
                    : Promise.resolve(),
                },
              ]}>
                <Space.Compact>
                  <Form.Item
                    name="processingTimeValue"
                    noStyle
                    rules={[
                      { required: true, message: "Please enter processing time." },
                      {
                        validator: (_, value) =>
                          value < 0 ? Promise.reject("Processing time cannot be less than 0.") : Promise.resolve(),
                      },
                    ]}
                  >
                    <Input type="number" step="0.1" placeholder="Value" className="w-full mt-1" name="processingTimeValue" />
                  </Form.Item>
                  <Form.Item
                    name="processingTimeUnit"
                    noStyle
                    rules={[{ required: true, message: "Please select unit." }]}
                  >
                    <Select defaultValue="H" options={[
                      { value: 'hours', label: 'H' },
                      { value: 'minutes', label: 'M' },
                    ]} name="processingTimeUnit" />

                  </Form.Item>

                </Space.Compact>
              </Form.Item>
            </div>


            <div>
              <p className="text-[#585F70] font-semibold mb-[2px]">Fees</p>
              <Form.Item name="fees" rules={[
                { required: true, message: 'Please enter fees.' },
                {
                  validator: (_, value) => value < 0
                    ? Promise.reject(new Error('Fees cannot be less than 0.'))
                    : Promise.resolve(),
                },
              ]}>
                <Input type="number" placeholder="Fees" className="w-full mt-1" />
              </Form.Item>
            </div>
            <div>
              <p className="text-[#585F70] font-semibold mb-[2px]">Description</p>
              <Form.Item name="description" rules={[
                { required: false, message: 'Please enter description.' },
              ]}>
                <Input type="text" placeholder="Description" className="w-full mt-1" />
              </Form.Item>
            </div>
          </div>

          <div className="flex justify-end mt-8">
            <LoadableButton
              className="bg-primary text-sm text-white font-semibold rounded-lg px-12 py-2 uppercase themeHover  duration-500"
              type="Submit"
              lable="Update"
              isLoading={isEditTraderLoading}
              loadingLable="Updating..."
            />
          </div>
        </Form>
      </ModalComponent>
    </div>
  );
}
